import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-572a6cc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-gray-200 p-8" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "py-6 text-gray-600 text-2xl p-5 underline underline-offset-8" }, " Bikes Management ", -1))
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { class: "border-2 border-gray-700 hover:bg-sky-700 text-gray-700 hover:text-white font-bold py-2 px-4 rounded-full" }
const _hoisted_5 = { class: "py-5 sm:px-20 sm:flex sm:flex-row items-center justify-center" }
const _hoisted_6 = { class: "py-5" }
const _hoisted_7 = {
  key: 1,
  class: "sm:flex sm:flex-row items-center justify-center"
}
const _hoisted_8 = { class: "table-auto w-full" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b border-gray-700 cursor-pointer" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Year"),
    /*#__PURE__*/_createElementVNode("th", null, "Price(€)"),
    /*#__PURE__*/_createElementVNode("th", null, "Edit"),
    /*#__PURE__*/_createElementVNode("th", null, "Delete")
  ])
], -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex items-center justify-center my-8" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "font-semibold" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "absolute inset-0 flex items-center justify-center" }
const _hoisted_17 = { class: "max-w-2xl p-6 mx-4 bg-white border-2 border-red-500 rounded-md shadow-xl" }
const _hoisted_18 = { class: "flex items-center justify-between" }
const _hoisted_19 = { class: "text-2xl" }
const _hoisted_20 = { class: "mt-4" }
const _hoisted_21 = {
  key: 0,
  class: "message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ClipLoader = _resolveComponent("ClipLoader")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, [
      _createVNode(_component_router_link, { to: "/add" }, {
        default: _withCtx(() => [
          _createElementVNode("button", _hoisted_4, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'add'],
              class: "pr-2"
            }),
            _createTextVNode("Add Bike ")
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.filterBikes && _ctx.filterBikes(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          type: "text",
          class: "mt-0 block w-full px-0.5 sm:mx-8 bg-gray-200 border-0 border-b-2 border-gray-400 focus:ring-0 focus:border-black w-full sm:w-1/3",
          placeholder: "Search your product here..."
        }, null, 512), [
          [_vModelText, _ctx.searchText]
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterBikes && _ctx.filterBikes(...args))),
            class: "rounded bg-gray-800 px-6 py-2.5 text-xs font-medium uppercase leading-tight text-white shadow-md transition duration-150 ease-in-out hover:bg-primary-700 hover:shadow-lg focus:bg-primary-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-primary-800 active:shadow-lg"
          }, " SEARCH ")
        ])
      ])
    ], 32),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_ClipLoader, {
          key: 0,
          color: _ctx.colorLoading
        }, null, 8, ["color"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bikes, (bike, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "border-b border-gray-700 hover:bg-sky-700 hover:text-white cursor-pointer",
                  key: index
                }, [
                  _createElementVNode("td", null, _toDisplayString(bike.title), 1),
                  _createElementVNode("td", null, _toDisplayString(bike.year), 1),
                  _createElementVNode("td", null, _toDisplayString(bike.price), 1),
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.editBike(bike._id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] })
                  ], 8, _hoisted_10),
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.deleteBike(bike._id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] })
                  ], 8, _hoisted_11)
                ]))
              }), 128))
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        disabled: _ctx.currentPage === 1,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.previousPage && _ctx.previousPage(...args))),
        class: "bg-gray-800 hover:bg-gray-600 text-white font-bold py-2 px-4 mx-2 rounded cursor-pointer"
      }, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'chevron-left'] })
      ], 8, _hoisted_13),
      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1),
      _createElementVNode("button", {
        disabled: _ctx.currentPage === _ctx.totalPages,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
        class: "bg-gray-800 hover:bg-gray-600 text-white font-bold py-2 px-4 mx-2 rounded cursor-pointer"
      }, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'chevron-right'] })
      ], 8, _hoisted_15)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("h3", _hoisted_19, [
            _createTextVNode(" Are you sure you want to delete this bike: "),
            _createElementVNode("b", null, _toDisplayString(_ctx.selectedBikeTitle), 1),
            _createTextVNode("? ")
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDeleteConfirmation = false)),
            class: "px-6 py-2 text-red-800 border border-red-500 rounded"
          }, " Cancel "),
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteBike && _ctx.confirmDeleteBike(...args))),
            class: "px-6 py-2 ml-2 text-white bg-gray-700 rounded"
          }, " Confirm ")
        ])
      ])
    ], 512), [
      [_vShow, _ctx.showDeleteConfirmation]
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}